export default __webpack_public_path__ + "static/media/warning--traffic-merges-right-buses--g1.dd325625.png";